function initialize(lat, lng) {
  var myLatLng = { lat, lng };

  var map = new google.maps.Map(document.getElementById('map'), {
    zoom: 10,
    center: myLatLng,
    scrollwheel: false
  });

  var marker = new google.maps.Marker({
    position: myLatLng,
    map: map
  });
}


$(function () {

  if ($("#map").length) {
    var mapDiv = $('#map');
    var lat = mapDiv.data('lat');
    var lng = mapDiv.data('lng');

    initialize(lat, lng);
  }

  $(".share-icons").sticky({topSpacing:120});

  $('.news-listing .load-more').click(function(e) {
    e.preventDefault();
    $(this).hide();
    $('.news-listing .more').css('display', 'flex');
  });
})